export interface FieldConfig {
    fieldkey: string;
    label: string;
    placeholder: string;
    required: boolean;
    type: 'text' | 'textarea';
    entryId: string;
}
export const fieldConfigs: {
    individual: FieldConfig[];
    company: FieldConfig[];
} = {
    individual: [
        { fieldkey: 'name', label: '個人稱呼', placeholder: '請輸入個人稱呼', required: true, type: 'text', entryId: 'entry.567777062' },
        { fieldkey: 'landline', label: '聯絡市話', placeholder: '請輸入聯絡市話 (格式範例：02-88888888)', required: true, type: 'text', entryId: 'entry.586323536' },
        { fieldkey: 'mobile', label: '聯絡手機', placeholder: '請輸入聯絡手機 (格式範例：0912345678)', required: true, type: 'text', entryId: 'entry.2137429854' },
        { fieldkey: 'email', label: '聯絡Email', placeholder: '請輸入聯絡Email', required: true, type: 'text', entryId: 'entry.352922959' },
        { fieldkey: 'address', label: '聯絡地址', placeholder: '請輸入聯絡地址', required: true, type: 'text', entryId: 'entry.1536666058' },
        { fieldkey: 'invoiceCarrier', label: '發票載具', placeholder: '請輸入發票載具', required: false, type: 'text', entryId: 'entry.1846776684' },
        { fieldkey: 'line', label: 'Line ID', placeholder: '請輸入Line ID', required: true, type: 'text', entryId: 'entry.1041865707' },
        { fieldkey: 'feedback', label: '留言訊息', placeholder: '請輸入留言訊息', required: true, type: 'textarea', entryId: 'entry.1605627697' },
    ],
    company: [
        { fieldkey: 'companyName', label: '公司名稱', placeholder: '請輸入公司名稱', required: true, type: 'text', entryId: 'entry.163497999' },
        { fieldkey: 'uniformNumber', label: '統一編號', placeholder: '請輸入統一編號', required: true, type: 'text', entryId: 'entry.1560690758' },
        { fieldkey: 'businessAddress', label: '營業地址', placeholder: '請輸入營業地址', required: true, type: 'text', entryId: 'entry.867516540' },
        { fieldkey: 'invoiceAddress', label: '發票地址', placeholder: '請輸入發票地址', required: true, type: 'text', entryId: 'entry.333942054' },
        { fieldkey: 'feedback', label: '留言訊息', placeholder: '請輸入留言訊息', required: true, type: 'textarea', entryId: 'entry.1605627697' },
    ]
};
